import request from '@/config/axios'

export interface SettledFirmVO {
  id?: number
  name: string
  creditCode?: string
  contactName?: string
  contactPhone?: string
  logoUrl?: string
  intro?: string
  status?: string
  canonical?: boolean
  holding?: boolean
  settleJson?: string
}

export interface SettledFirmPageReqVO {
  pageNo?: number
  pageSize?: number
  name?: string
  status?: string
  holding?: boolean
  canonical?: boolean
}

export const SettledFirmApi = {
  getPage: async (params: SettledFirmPageReqVO) => {
    return await request.get({ url: '/lawyer/firm/page', params })
  },
  /** 下拉简表（已审批）；需 lawyer:lawyer:query */
  getSimpleList: async (params?: { pageNo?: number; pageSize?: number; status?: string }) => {
    return await request.get({ url: '/lawyer/firm/simple-list', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/lawyer/firm/get', params: { id } })
  },
  create: async (data: SettledFirmVO) => {
    return await request.post({ url: '/lawyer/firm/create', data })
  },
  update: async (data: SettledFirmVO) => {
    return await request.put({ url: '/lawyer/firm/update', data })
  },
  updateStatus: async (id: number, status: string) => {
    return await request.put({ url: '/lawyer/firm/update-status', params: { id, status } })
  },
  /** 开通机构主账号（/firm 登录） */
  openAccount: async (data: {
    firmId: number
    username: string
    password: string
    mobile?: string
    nickname?: string
  }) => {
    return await request.post({ url: '/lawyer/firm/open-account', data })
  },
  resetAccountPassword: async (data: { firmId: number; newPassword: string }) => {
    return await request.put({ url: '/lawyer/firm/reset-account-password', data })
  },
  hasMainAccount: async (firmId: number) => {
    return await request.get({ url: '/lawyer/firm/has-main-account', params: { firmId } })
  }
}
